












































import mixins from 'vue-typed-mixins'
import I18N from '@/components/I18N.ts'
import SearchInput from '@/components/SearchInput.vue'
import axios from 'axios'

interface Data {
  stats: {
    lexemes: string
    wordforms: string
  }
  term: string
}

export default mixins(I18N).extend({
  name: 'home',
  components: {
    SearchInput
  },
  data (): Data {
    return {
      stats: {
        lexemes: '…',
        wordforms: '…'
      },
      term: ''
    }
  },
  methods: {
    submitSearch (): void {
      if (this.term) {
        this.$router.push({ name: 'lexemes', query: { s: this.term } })
      }
    }
  },
  mounted (): void {
    this.$store.dispatch('clearTitle')

    axios.get(`${process.env.VUE_APP_API_URL}/lexemes/count`)
      .then(response => {
        this.stats.lexemes = `<span class="badge badge-dark">${response.data.toLocaleString()}</span>`
      })
      .catch(error => {
        console.error(error)
      })
    axios.get(`${process.env.VUE_APP_API_URL}/wordforms/count`)
      .then(response => {
        this.stats.wordforms = `<span class="badge badge-secondary">${response.data.toLocaleString()}</span>`
      })
      .catch(error => {
        console.error(error)
      })
  }
})
